export enum Channels {
  CCR = 'ccr',
  RETAIL = 'retail',
}
